
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.9001 5.00001C15.7301 5.00001 15.5801 5.09001 15.4901 5.23001L15.4201 5.38001L10.2401 17.03C10.0801 17.32 9.98011 17.64 9.98011 17.99C9.98011 19.1 10.8801 20 11.9901 20C12.9501 20 13.7601 19.32 13.9501 18.41L13.9601 18.38L16.4001 5.50001C16.4001 5.22001 16.1801 5.00001 15.9001 5.00001ZM2.06012 10.06C2.57012 10.57 3.39012 10.61 3.95012 10.15C6.71012 7.89001 10.1901 6.97001 13.5301 7.39001L14.7201 4.71001C10.3701 3.93001 5.76012 5.01001 2.15012 7.96001C1.51012 8.49001 1.47012 9.47001 2.06012 10.06ZM21.9401 10.06C22.5301 9.47001 22.4901 8.49001 21.8401 7.96001C20.4801 6.85001 18.9801 6.01001 17.4001 5.43001L16.8701 8.25001C18.0001 8.72001 19.0601 9.34001 20.0401 10.14C20.6201 10.6 21.4301 10.57 21.9401 10.06ZM17.9101 14.09C18.5101 13.49 18.4701 12.46 17.7701 11.97C17.3101 11.64 16.8301 11.36 16.3301 11.11L15.7801 14.03C15.8901 14.1 16.0001 14.17 16.1001 14.25C16.6701 14.65 17.4301 14.57 17.9101 14.09ZM6.08012 14.08C6.58012 14.58 7.35012 14.62 7.93012 14.21C8.87012 13.55 9.94011 13.15 11.0301 12.99L12.3101 10.11C10.1801 10.05 8.03012 10.65 6.22012 11.95C5.53012 12.46 5.48012 13.48 6.08012 14.08Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-network-check`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNetworkCheck

    ```js
    <b-new-b-icon-network-check />
    ```
</docs>


